// frontend/src/lib/auth.js
import { supabase } from "@/lib/supabase";

export async function signIn(email, password) {
  if (!supabase) throw new Error("Supabase not configured");
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

export async function signOut() {
  if (!supabase) return;
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export function onAuthStateChange(callback) {
  if (!supabase) return { data: { subscription: { unsubscribe: () => {} } } };
  return supabase.auth.onAuthStateChange(callback);
}

export async function getSession() {
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  return data.session;
}

export async function resetPassword(email) {
  if (!supabase) throw new Error("Supabase not configured");
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/admin`,
  });
  if (error) throw error;
}

export async function updatePassword(newPassword) {
  if (!supabase) throw new Error("Supabase not configured");
  const { error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) throw error;
}

export async function checkSiteAdminPermission(userId) {
  if (!supabase) return false;
  const entityUuid = process.env.REACT_APP_ENTITY_578_UUID;
  if (!entityUuid) {
    console.warn("REACT_APP_ENTITY_578_UUID is not set — admin permission check will fail");
    return false;
  }
  const { data, error } = await supabase.schema("core").rpc("user_has_permission", {
    permission: "content:*",
    entity_uuid: entityUuid,
    user_uuid: userId,
  });
  return !error && data === true;
}
